import { render } from "./ListadoDhs.vue?vue&type=template&id=4f1fe65c&scoped=true"
import script from "./ListadoDhs.vue?vue&type=script&lang=js"
export * from "./ListadoDhs.vue?vue&type=script&lang=js"

import "./ListadoDhs.vue?vue&type=style&index=0&id=4f1fe65c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1fe65c"]])

export default __exports__